'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouterConst = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.getRedirectRoute = getRedirectRoute;
exports.getQuery = getQuery;
exports.getPath = getPath;
exports.getPathWithWelcome = getPathWithWelcome;
exports.getQueryForEmailLink = getQueryForEmailLink;
exports.getPathForEmailLinkWithQuery = getPathForEmailLinkWithQuery;
exports.getPathForEmailLink = getPathForEmailLink;
exports.getErrorRetryPath = getErrorRetryPath;
exports.navigateAfterPasswordReset = navigateAfterPasswordReset;
exports.validateAppQueryParam = validateAppQueryParam;

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouterConst = exports.RouterConst = {
  Addresses: 'addresses',
  AllProviders: 'allproviders',
  ApproveAgreements: 'approveagreements',
  Authorize: 'authorize',
  Authorization: 'authorization',
  AuthorizationError: 'authorizationerror',
  AuthorizationExpired: 'authorizationexpired',
  AuthorizationNow: 'authorizationnow',
  AuthorizationOptions: 'authorizationoptions',
  AuthorizationSSOSuccess: 'authorizationssosuccess',
  Communication: 'communication',
  ConfirmForgotPassword: 'confirmforgotpassword',
  ContactUs: 'contactus',
  ContactUsFeedback: 'contactusfeedback',
  ErrorRetry: 'errorretry',
  ExistingAccount: 'existingaccount',
  Facebook: 'fb',
  Amazon: 'amazon',
  Apple: 'apple',
  Google: 'google',
  ForgotPassword: 'forgotpassword',
  LinkAccount: 'linkaccount',
  LinkExpired: 'linkexpired',
  LoginEmail: 'loginemail',
  LoginOptions: 'loginoptions',
  NotFound: 'notfound',
  QRLogin: 'qrlogin',
  QRSignUp: 'qrsignup',
  ProviderNotListed: 'providernotlisted',
  ResetPassword: 'resetpassword',
  CreatePasswordAndLinkToProfile: 'createpasswordandlink',
  ResetPasswordConfirmation: 'resetpasswordconfirmation',
  ResetPasswordExpired: 'resetpasswordexpired',
  SignUpEmail: 'signupemail',
  SignUpOptions: 'signupoptions',
  SwitchProvider: 'switchprovider',
  TokenAuthorize: 'tokenauthorize',
  TopProviders: 'topproviders',
  TrialExpired: 'trialexpired',
  TV: 'tv',
  Code: 'code',
  TVCodeForm: ":product/tv",
  CodeForm: ":product/code",
  TVLoginSuccess: "tvloginsuccess",
  ValidateResetPassword: 'validateresetpassword',
  ValidateSSO: 'validatesso',
  Version: 'version',
  Welcome: 'welcome'
};

function getRedirectRoute(routeName, query) {
  if (query.redirect_route) {
    routeName = query.redirect_route;
    delete query.redirect_route;
  }

  return routeName;
}

function getQuery() {
  return _url2.default.parse(window.location.href, true).query;
}

function getPath(route) {
  var query = _url2.default.parse(window.location.href, true).query;
  return '/' + route + '?' + _querystring2.default.stringify(query);
}

function getPathWithWelcome(route) {
  return getPath(RouterConst.Welcome + '/' + route);
}

function getQueryForEmailLink(query, language) {
  var clonedQuery = (0, _assign2.default)({}, query);
  delete clonedQuery.token;
  delete clonedQuery.exclude_header;
  clonedQuery.language = language;
  return _querystring2.default.stringify(clonedQuery);
}

function getPathForEmailLinkWithQuery(query, route, language) {
  return '/' + route + '?' + getQueryForEmailLink(query, language);
}

function getPathForEmailLink(route, language) {
  var query = getQuery();
  return getPathForEmailLinkWithQuery(query, route, language);
}

function getErrorRetryPath(query) {
  var path = void 0;
  if (query) {
    path = '/' + RouterConst.ErrorRetry + '?' + _querystring2.default.stringify(query);
  } else {
    path = getPath(RouterConst.ErrorRetry);
  }
  return path;
}

var HOST_WITH_OWN_LOGIN_PAGE = ['store.stingray.com', 'store-test.stingray.com', 'store-stage.stingray.com'];

function navigateAfterPasswordReset(redirectUri, pushState) {
  try {
    var host = new URL(redirectUri).hostname;
    if (HOST_WITH_OWN_LOGIN_PAGE.includes(host)) {
      window.location.href = redirectUri;
      return;
    }
  } catch (e) {
    console.warn('navigateAfterPasswordReset: invalid redirectUri', redirectUri);
  }
  pushState(getPath(RouterConst.Welcome + '/' + RouterConst.LoginEmail));
}

function validateAppQueryParam(query) {
  var value = false;
  if (!(query.redirect_uri && query.client_id)) {
    console.log('Missing params redirect_uri or client_id');
  } else {
    value = true;
  }
  return value;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Router.js
// module id = 19
// module chunks = 0